// **React Imports
import React, { memo, useMemo } from 'react'

// **MUI Imports
import { Typography } from '@mui/material'

// **Third party Imports
import DOMPurify from 'dompurify'

const SanitizedHTMLOptionItem = ({ option }) => {
  const sanitizedContent = useMemo(() => {
    return DOMPurify.sanitize(option?.content || '')
  }, [option])
  return (
    <Typography
      className="html-inject"
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  )
}

export default memo(SanitizedHTMLOptionItem)
